import {UnstyledButton} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';

export const StyledCircleButton = styled(UnstyledButton)`
  height: 50px;
  width: 50px;
  box-sizing: border-box;
  flex-basis: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-shadow: 0 10px 15px 0 rgba(0, 0, 0, 0.08), 0 2px 2px 0 rgba(0, 0, 0, 0.05);
`;
